//import { businessInsightsHandlers } from "./businessInsightsHandlers";
import { generalHandlers } from "./generalHandlers";
import { forecasterHandlers } from "./foreCasterHandlers";

export const discussionHandlerMap = {
  actionItems: generalHandlers,
  businessInsights: generalHandlers,
  receipts: generalHandlers,
  //businessInsights: businessInsightsHandlers,
  activityNotes: generalHandlers,
  forecaster: forecasterHandlers,
  manualExpense: generalHandlers,
  dataAccuracy: generalHandlers,
};
